import { useHistory } from 'react-router-dom';
import { Button, Link, Typography } from '@mui/material';
import { useAuth_ForgotPasswordMutation } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

type Props = {
  email: string;
};

const SentResetActions = ({ email }: Props) => {
  const history = useHistory();

  const [forgotPassword, { loading: isLoadingForgotPassword }] = useAuth_ForgotPasswordMutation({
    onError: (e) =>
      showAlert({
        message: 'Error resetting password: ' + e.message,
        severity: NotificationSeverity.ERROR,
      }),
  });

  return (
    <div style={{ textAlign: 'center', marginTop: '50px', marginBottom: '50px' }}>
      <Button
        type="submit"
        variant="contained"
        color="secondary"
        disabled={isLoadingForgotPassword}
        onClick={() => forgotPassword({ variables: { email } })}
      >
        Send the Link again
      </Button>
      <Typography style={{ marginTop: '25px', textDecoration: 'underline', cursor: 'pointer' }}>
        <Link onClick={() => history.push('/')}>Go back to the sign in page</Link>
      </Typography>
    </div>
  );
};

export default SentResetActions;
